(function () {
  'use strict';

  var ELIGIBLE_PRODUCT_IDS = {
    '5291622170775': true, // Bossa Nova
    '5294850048151': true, // Ipanema
    '5305726140567': true, // Samba
    '7994224836759': true  // Decaf Tropicalia
  };

  var PLANS = [
    { id: '3258548375', label: 'Every 2 weeks' },
    { id: '3258581143', label: 'Every month' },
    { id: '3258613911', label: 'Every 6 weeks' },
    { id: '3258646679', label: 'Every 2 months' }
  ];

  var activeCart = null;
  var freshSyncTimer = null;
  var reconcileTimer = null;
  var syncInFlight = false;
  var syncAgain = false;
  var observer = null;
  var quantityLocks = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function cartRoot() {
    return document.getElementById('cart');
  }

  function moneyPlanId(item) {
    var allocation = item && item.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    return plan && plan.id ? String(plan.id) : '';
  }

  function isEligible(item) {
    return !!(item && ELIGIBLE_PRODUCT_IDS[String(item.product_id)]);
  }

  function rowVariant(row) {
    if (!row) return '';
    var input = q('.updates[data-id]', row);
    if (input && input.dataset && input.dataset.id) return String(input.dataset.id);

    var link = q('a.cart__item[href*="variant="]', row);
    if (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        var variant = url.searchParams.get('variant');
        if (variant) return String(variant);
      } catch (e) {}
    }
    return '';
  }

  function rowLineIndex(row) {
    var input = row && q('.updates[data-line-id]', row);
    if (!input) return 0;
    var n = parseInt(input.getAttribute('data-line-id'), 10);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function productRows(root) {
    if (!root) return [];
    return qa('li', root).filter(function (row) {
      return !!q('a.cart__item', row) && !!q('.updates[data-id]', row);
    });
  }

  function directPanel(row) {
    if (!row) return null;
    var children = row.children || [];
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains('bgc-drawer-purchase')) {
        return children[i];
      }
    }
    return null;
  }

  function installStyles() {
    if (document.getElementById('bgc-drawer-purchase-styles')) return;
    var style = document.createElement('style');
    style.id = 'bgc-drawer-purchase-styles';
    style.textContent = [
      '#cart .bgc-drawer-purchase{margin:10px 18px 14px;padding:10px 12px;border:1px solid rgba(142,45,36,.20);border-radius:10px;background:#fffaf6;box-shadow:0 2px 8px rgba(0,0,0,.04);font-size:12px;line-height:1.3;transition:opacity .12s ease}',
      '#cart .bgc-drawer-purchase.is-removing{visibility:hidden;opacity:0;pointer-events:none}',
      '#cart .bgc-drawer-purchase.is-busy{opacity:.64;pointer-events:none}',
      '#cart .bgc-drawer-purchase__title{font-weight:700;color:#8e2d24;margin:0 0 7px;text-transform:uppercase;letter-spacing:.04em;font-size:11px}',
      '#cart .bgc-drawer-purchase__modes{display:flex;gap:6px}',
      '#cart .bgc-drawer-purchase__mode{flex:1;border:1px solid #c9a56a;background:#fff;color:#7e2a22;border-radius:7px;padding:7px 6px;font:inherit;font-weight:700;cursor:pointer}',
      '#cart .bgc-drawer-purchase__mode.is-active{background:#dda02b;color:#fff;border-color:#dda02b}',
      '#cart .bgc-drawer-purchase__frequency{margin-top:7px}',
      '#cart .bgc-drawer-purchase__frequency[hidden]{display:none!important}',
      '#cart .bgc-drawer-purchase__frequency select{width:100%;border:1px solid rgba(126,42,34,.28);border-radius:7px;background:#fff;padding:7px 8px;color:#6f2721;font:inherit}',
      '#cart .bgc-drawer-purchase__status{min-height:0;margin-top:5px;color:#8e2d24;font-size:10px}'
    ].join('');
    document.head.appendChild(style);
  }

  function cleanupLegacyPanels() {
    qa('#cart .bgc-cart-purchase').forEach(function (node) {
      node.remove();
    });
  }

  function buildPanel(item) {
    var box = document.createElement('div');
    box.className = 'bgc-drawer-purchase';
    box.innerHTML = [
      '<div class="bgc-drawer-purchase__title">Purchase Options</div>',
      '<div class="bgc-drawer-purchase__modes">',
      '  <button type="button" class="bgc-drawer-purchase__mode" data-bgc-mode="one">One-Time</button>',
      '  <button type="button" class="bgc-drawer-purchase__mode" data-bgc-mode="sub">Subscribe &amp; Save</button>',
      '</div>',
      '<div class="bgc-drawer-purchase__frequency" hidden>',
      '  <select aria-label="Delivery frequency">' + PLANS.map(function (plan) {
        return '<option value="' + plan.id + '">' + plan.label + '</option>';
      }).join('') + '</select>',
      '</div>',
      '<div class="bgc-drawer-purchase__status" aria-live="polite"></div>'
    ].join('');
    setPanelState(box, item);
    return box;
  }

  function setPanelState(box, item) {
    if (!box || !item) return;
    var planId = moneyPlanId(item);
    var isSubscription = !!planId;
    box.dataset.key = String(item.key || '');
    box.dataset.variant = String(item.variant_id || '');
    box.dataset.product = String(item.product_id || '');
    box.classList.remove('is-removing');

    var one = q('[data-bgc-mode="one"]', box);
    var sub = q('[data-bgc-mode="sub"]', box);
    var frequency = q('.bgc-drawer-purchase__frequency', box);
    var select = q('select', box);

    if (one) {
      one.classList.toggle('is-active', !isSubscription);
      one.setAttribute('aria-pressed', !isSubscription ? 'true' : 'false');
    }
    if (sub) {
      sub.classList.toggle('is-active', isSubscription);
      sub.setAttribute('aria-pressed', isSubscription ? 'true' : 'false');
    }
    if (frequency) frequency.hidden = !isSubscription;
    if (select && planId) select.value = planId;
  }

  function scheduleReconcile(delay, cart, attempt) {
    if (cart) activeCart = cart;
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcile(activeCart, attempt || 0);
    }, typeof delay === 'number' ? delay : 80);
  }

  function unmatchedSameVariant(items, usedKeys, variant) {
    var matches = items.filter(function (item) {
      return String(item.variant_id) === String(variant) && !usedKeys[String(item.key)];
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function reconcile(cart, attempt) {
    var root = cartRoot();
    if (!root || !cart || !Array.isArray(cart.items)) return;

    var rows = productRows(root);
    var items = cart.items;
    var currentAttempt = attempt || 0;

    if (rows.length !== items.length) {
      if (currentAttempt < 5) {
        var waits = [70, 120, 190, 300, 430];
        scheduleReconcile(waits[currentAttempt] || 430, cart, currentAttempt + 1);
      }
      return;
    }

    var byKey = {};
    items.forEach(function (item) {
      byKey[String(item.key)] = item;
    });

    var usedKeys = {};
    var mappedRows = [];

    rows.forEach(function (row) {
      var variant = rowVariant(row);
      var item = null;
      var rememberedKey = row.dataset && row.dataset.bgcCartKey ? String(row.dataset.bgcCartKey) : '';

      if (rememberedKey && byKey[rememberedKey] && String(byKey[rememberedKey].variant_id) === String(variant) && !usedKeys[rememberedKey]) {
        item = byKey[rememberedKey];
      }

      if (!item) {
        var nativeLine = rowLineIndex(row);
        if (nativeLine && items[nativeLine - 1] && String(items[nativeLine - 1].variant_id) === String(variant) && !usedKeys[String(items[nativeLine - 1].key)]) {
          item = items[nativeLine - 1];
        }
      }

      if (!item) item = unmatchedSameVariant(items, usedKeys, variant);

      if (!item) return;

      var key = String(item.key);
      usedKeys[key] = true;
      row.dataset.bgcCartKey = key;
      row.dataset.bgcVariant = String(item.variant_id || '');
      mappedRows.push(row);

      var panel = directPanel(row);
      if (!isEligible(item)) {
        if (panel) panel.remove();
        return;
      }

      if (!panel) {
        panel = buildPanel(item);
        var anchor = q('a.cart__item', row);
        if (anchor && anchor.nextSibling) row.insertBefore(panel, anchor.nextSibling);
        else row.appendChild(panel);
      } else {
        setPanelState(panel, item);
      }
    });

    rows.forEach(function (row) {
      if (mappedRows.indexOf(row) !== -1) return;
      var panel = directPanel(row);
      if (panel) panel.remove();
      if (row.dataset) {
        delete row.dataset.bgcCartKey;
        delete row.dataset.bgcVariant;
      }
    });
  }

  function getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart read failed');
      return response.json();
    });
  }

  function runFreshSync() {
    if (syncInFlight) {
      syncAgain = true;
      return;
    }
    syncInFlight = true;
    getCart().then(function (cart) {
      activeCart = cart;
      scheduleReconcile(60, cart, 0);
    }).catch(function () {
      // Native cart remains authoritative; fail quietly and wait for next cart event.
    }).finally(function () {
      syncInFlight = false;
      if (syncAgain) {
        syncAgain = false;
        scheduleFreshSync(90);
      }
    });
  }

  function scheduleFreshSync(delay) {
    clearTimeout(freshSyncTimer);
    freshSyncTimer = setTimeout(runFreshSync, typeof delay === 'number' ? delay : 180);
  }

  function findItemByKey(cart, key) {
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key) === String(key)) return cart.items[i];
    }
    return null;
  }

  function updateSellingPlan(box, targetPlan) {
    if (!box || box.classList.contains('is-busy')) return;
    var key = String(box.dataset.key || '');
    if (!key) {
      scheduleFreshSync(0);
      return;
    }

    box.classList.add('is-busy');
    var status = q('.bgc-drawer-purchase__status', box);
    if (status) status.textContent = 'Updating…';

    getCart().then(function (cart) {
      activeCart = cart;
      var item = findItemByKey(cart, key);
      if (!item) throw new Error('Cart line no longer exists');

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          selling_plan: targetPlan || null
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart change failed');
        return response.json();
      });
    }).then(function (cart) {
      activeCart = cart;
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      } catch (e) {}
      scheduleReconcile(90, cart, 0);
      if (status) status.textContent = '';
    }).catch(function () {
      if (status) status.textContent = 'Please try again.';
      scheduleFreshSync(80);
    }).finally(function () {
      box.classList.remove('is-busy');
    });
  }

  function handlePanelClick(event) {
    var button = event.target && event.target.closest ? event.target.closest('.bgc-drawer-purchase__mode') : null;
    if (!button) return;
    var box = button.closest('.bgc-drawer-purchase');
    if (!box) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.getAttribute('data-bgc-mode') === 'one') {
      updateSellingPlan(box, null);
    } else {
      var select = q('select', box);
      updateSellingPlan(box, (select && select.value) || PLANS[0].id);
    }
  }

  function handlePanelChange(event) {
    var select = event.target;
    if (!select || !select.matches('.bgc-drawer-purchase__frequency select')) return;
    var box = select.closest('.bgc-drawer-purchase');
    if (!box) return;
    updateSellingPlan(box, select.value);
  }

  function quantityRow(control) {
    return control && control.closest ? control.closest('li') : null;
  }

  function lockRapidQuantityClick(event) {
    var control = event.target && event.target.closest ? event.target.closest('#cart .plus, #cart .minus') : null;
    if (!control || event.isTrusted === false) return;

    var row = quantityRow(control);
    if (!row) return;
    var now = Date.now();
    var until = quantityLocks ? (quantityLocks.get(row) || 0) : parseInt(row.getAttribute('data-bgc-qty-lock-until') || '0', 10);

    if (until > now) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    var nextUntil = now + 480;
    if (quantityLocks) quantityLocks.set(row, nextUntil);
    else row.setAttribute('data-bgc-qty-lock-until', String(nextUntil));

    var input = q('.updates', row);
    var panel = directPanel(row);
    var value = input ? parseInt(input.value, 10) : NaN;
    if (panel && control.classList.contains('minus') && value === 1) {
      panel.classList.add('is-removing');
    }

    setTimeout(function () {
      if (quantityLocks) quantityLocks.delete(row);
      else row.removeAttribute('data-bgc-qty-lock-until');
    }, 520);
  }

  function handleNativeCartClick(event) {
    var root = cartRoot();
    if (!root || !event.target || !root.contains(event.target)) return;

    var control = event.target.closest ? event.target.closest('.plus, .minus, .trash-alt, [class*="trash"], [data-remove], a[href*="change"], a[href*="remove"]') : null;
    if (!control) return;

    var row = quantityRow(control);
    if (row) {
      var panel = directPanel(row);
      if (panel && (control.classList.contains('trash-alt') || control.matches('[data-remove], [class*="trash"], a[href*="remove"]'))) {
        panel.classList.add('is-removing');
      }
    }

    scheduleFreshSync(520);
  }

  function handleNativeCartChange(event) {
    if (!event.target || !event.target.matches('#cart .updates')) return;
    scheduleFreshSync(520);
  }

  function mutationTouchesNativeRows(mutation) {
    var nodes = [];
    if (mutation.addedNodes) nodes = nodes.concat(Array.prototype.slice.call(mutation.addedNodes));
    if (mutation.removedNodes) nodes = nodes.concat(Array.prototype.slice.call(mutation.removedNodes));
    return nodes.some(function (node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.classList && node.classList.contains('bgc-drawer-purchase')) return false;
      return (node.matches && (node.matches('li') || node.matches('a.cart__item'))) ||
        (node.querySelector && !!node.querySelector('a.cart__item, .updates[data-id]'));
    });
  }

  function observeDrawer() {
    if (observer) observer.disconnect();
    var root = cartRoot();
    if (!root || typeof MutationObserver === 'undefined') return;

    observer = new MutationObserver(function (mutations) {
      var nativeChanged = mutations.some(mutationTouchesNativeRows);
      if (nativeChanged) scheduleFreshSync(80);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function handleCartUpdated(event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart && Array.isArray(cart.items)) {
      activeCart = cart;
      scheduleReconcile(90, cart, 0);
    } else {
      scheduleFreshSync(90);
    }
  }

  function start() {
    installStyles();
    cleanupLegacyPanels();
    observeDrawer();
    scheduleFreshSync(0);
  }

  document.addEventListener('click', lockRapidQuantityClick, true);
  document.addEventListener('click', handlePanelClick, false);
  document.addEventListener('change', handlePanelChange, false);
  document.addEventListener('click', handleNativeCartClick, false);
  document.addEventListener('change', handleNativeCartChange, false);
  document.addEventListener('cart:updated', handleCartUpdated, false);
  document.addEventListener('shopify:section:load', function () {
    cleanupLegacyPanels();
    observeDrawer();
    scheduleFreshSync(80);
  });
  window.addEventListener('pageshow', function () {
    observeDrawer();
    scheduleFreshSync(80);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
